const textFrag = `
precision highp float;
uniform sampler2D map;
uniform sampler2D noiseTex;
uniform float time;
uniform float offset;
varying vec2 vUv;

void main()	{
  vec2 uv = vUv;

  float n4 = texture2D(noiseTex, uv * 4.0 + time *0.04).r;
  float n5 = texture2D(noiseTex, uv * 2.0 + time *0.02).r;
  uv += n4 * 0.0025 + n5 * 0.0012;

	vec4 col = texture2D(map, uv);
  gl_FragColor = col;
}
`;
export default textFrag;
